import Svg, { Path, Rect } from "react-native-svg";
import { GetProps } from "tamagui";

const RxIcon = ({
  color,
  backgroundColor,
  ...props
}: GetProps<typeof Svg> & { backgroundColor?: string }) => (
  <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <Rect width={24} height={24} rx={12} fill={backgroundColor} />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 7C7.5 6.44772 7.94772 6 8.5 6H11C12.3807 6 13.5 7.11929 13.5 8.5V9C13.5 10.3807 12.3807 11.5 11 11.5H10.7071L13.75 14.5429L15.6464 12.6464C15.8417 12.4512 16.1583 12.4512 16.3536 12.6464C16.5488 12.8417 16.5488 13.1583 16.3536 13.3536L14.4571 15.25L16.3536 17.1464C16.5488 17.3417 16.5488 17.6583 16.3536 17.8536C16.1583 18.0488 15.8417 18.0488 15.6464 17.8536L13.75 15.9571L11.8536 17.8536C11.6583 18.0488 11.3417 18.0488 11.1464 17.8536C10.9512 17.6583 10.9512 17.3417 11.1464 17.1464L13.0429 15.25L9.29289 11.5H8.5V15C8.5 15.2761 8.27614 15.5 8 15.5C7.72386 15.5 7.5 15.2761 7.5 15V7ZM8.5 10.5H11C11.8284 10.5 12.5 9.82843 12.5 9V8.5C12.5 7.67157 11.8284 7 11 7H8.5V10.5Z"
      fill={color}
    />
  </Svg>
);

export default RxIcon;
